import React from 'react'
import '../css/fleetservice.css';
import cabina from '../assets/images/flota/cabo/cabina-Interior.png'
/*import cabina_vip from '../assets/images/flota/cabo/cabina-dos-camas.png'*/
import sleeping from '../assets/images/flota/cabo/sleeping-pods.jpg'
import sleeping2 from '../assets/images/flota/cabo/sleeping-pods2.png'
import sleeping3 from '../assets/images/flota/cabo/sleeping-pods3.jpg'

import salon from '../assets/images/flota/cabo/sala-asientos.png'
import salon_vip from '../assets/images/flota/cabo/sala-asientos-VIP.png'
import cabina_vip from '../assets/images/flota/cabo/cabina-vip.jpg'
import cabina_accessible from '../assets/images/flota/cabo/cabina-accessible.png'


import bar from '../assets/images/flota/cabo/bar.jpg'
import bebida01 from '../assets/images/flota/cabo/bebidas02.webp'
import bebida02 from '../assets/images/flota/cabo/bebidas01.webp'
import bebida03 from '../assets/images/flota/cabo/bebidas03.webp'
import bebida04 from '../assets/images/flota/cabo/bebidas04.webp'
import doctor from '../assets/images/cirujano.png'
import Footer from './Footer'
import { useTranslation } from 'react-i18next';

import ImageSlider from './sliders/SliderFlota';

export default function Fleetservice_mex() {
    const { t } = useTranslation('servicioMexico');
    
    const imagesCabinas = [    
        {
            image: cabina,
        },
        {
            image: cabina_vip,
        }, 
        {
            image: cabina_accessible
        }          
        // Agrega más imágenes según sea necesario
    ];


    const imagesCapsula = [    
        {
            image: sleeping,
        },
        {
            image: sleeping2,
        }, 
        {
            image: sleeping3
        }          
        // Agrega más imágenes según sea necesario
    ];

    const images = [    
        {
            image: salon,
        },
        {
            image: salon_vip,
        },           
        // Agrega más imágenes según sea necesario
    ];

    const imagesBar = [    
        {
            image: bebida01,
        },
        {
            image: bebida02,
        },  
         {
            image: bebida03,
        },
        {
            image: bebida04,
        },            
        // Agrega más imágenes según sea necesario
    ];
  return (
    <>
    
    <section>
        <div className='header_section'>
            <div className='container header_section_box'>
                <div className='header_section_title'>
                    <h3>Cabo Star</h3>
                    <p>{t('header_section_title_p')}</p>
                </div>                
            </div>
        </div>
    </section>
    <section className='fleetserices_ship'>   
        <section className='fleetserices'>
            <div className='container'>
                <div className='fleetserices_content'>
                    <div className='fleetserices_box'>
                        <div className='fleetserices_img_box'>
                            {/*}
                            <div className='fleetserices_img'>
                                <img src={cabina} alt='cabina cabo star flota baja ferries' />
                            </div>*/}
                            <ImageSlider images={imagesCabinas} /> 
                            
                        </div>
                        <div className='fleetserices_text_box'>
                            <div className='fleetserices_text'>
                                <h2>{t('fleetserices_cabinas')}</h2>
                                <p>{t('fleetserices_cabinas_text')}</p>
                                <p>{t('fleetserices_cabinas_text2')}</p>
                                <div className='fleetserices_btn'>
                                    <button>{t('fleetserices_btn')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='fleetserices_box'>
                        <div className='fleetserices_img_box'>
                            {/*}
                            <div className='fleetserices_img'>
                                <img src={cabina} alt='cabina cabo star flota baja ferries' />
                            </div>*/}
                            <ImageSlider images={imagesCapsula} /> 
                        </div>
                        <div className='fleetserices_text_box'>
                            <div className='fleetserices_text'>
                                <h2>{t('fleetserices_capsula')}</h2>
                                <p>{t('fleetserices_capsula_text')}</p>
                                <p>{t('fleetserices_capsula_text1')}</p>
                                <p><strong>{t('fleetserices_capsula_text2')}</strong></p>
                                <p>{t('fleetserices_capsula_text3')}</p>
                                <p>{t('fleetserices_capsula_text4')}</p>
                                                                                                
                                <div className='fleetserices_btn'>
                                    <button>{t('fleetserices_btn')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='fleetserices_box'>
                        <div className='fleetserices_img_box'>                                                   
                            <ImageSlider images={images} />                             
                            {/*<img src={salon} alt='cabo star flota baja ferries' />*/}                           
                        </div>
                        <div className='fleetserices_text_box'>
                            <div className='fleetserices_text'>
                                <h2>{t('fleetserices_salon')}</h2>
                                <p>{t('fleetserices_salon_text')}</p>
                                <p>{t('fleetserices_salon_text2')}</p>
                                <div className='fleetserices_btn'>
                                    <button>{t('fleetserices_btn')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='fleetserices_box'>
                        <div className='fleetserices_img_box'>                          
                            <ImageSlider images={imagesBar} />  
                        </div>
                        <div className='fleetserices_text_box'>
                            <div className='fleetserices_text'>
                                <h2>{t('fleetserices_restaurante')}</h2>
                                <p>{t('fleetserices_restaurante_text1')}</p>
                                <p>{t('fleetserices_restaurante_text2')}</p>
                                <p>{t('fleetserices_restaurante_text3')}</p>
                                <p>{t('fleetserices_restaurante_text4')}</p>
                               {/*<p>{t('fleetserices_restaurante_text5')}</p>
                                <p>{t('fleetserices_restaurante_text6')}</p>*/}
                                <div className='fleetserices_btn'>
                                    <button>{t('fleetserices_btn')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className='fleetserices_bottom entretenimiento'>
            <div className='container'>
                <div className='fleetserices_content'>
                    <div className='fleetserices_box'>
                    
                        <div className='fleetserices_img_box'>
                            <img src={bar} alt='bar cabo star baja ferries' />   
                        </div>
                        <div className='fleetserices_text_box'>
                            <div className='fleetserices_text'>
                                <h2>{t('fleetserices_bar')}</h2>
                                <p>{t('fleetserices_bar_text2')}</p>

                                <div className='fleetserices_btn'>
                                    <button>{t('fleetserices_btn')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>            
            </div>
        </section>
        <section className='fleetserices_medico'>
            <div className='container'>
                <div className='fleetserices_content medico'>
                    <div className='fleetserices_box'>
                    <div className='fleetserices_img_box'>
                            <div className='fleetserices_img_medico'>
                                <img src={doctor} alt='cabo star flota baja ferries' />
                            </div>
                        </div>
                        <div className='fleetserices_text_box'>
                            <div className='fleetserices_text_medico'>
                                <h2>{t('fleetserices_medico')}</h2>
                                <p>{t('fleetserices_medico_text')}</p>                                
                                <div className='fleetserices_medico_icons'>
                                    <p><i class="fi fi-rr-syringe"></i></p>
                                    <p><i class="fi fi-rr-stethoscope"></i></p>
                                    <p><i class="fi fi-rr-capsules"></i></p>                                                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>            
            </div>
        </section>
    </section>
    <Footer/>
    </>
  )
}
